import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, role }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === undefined) {
        return (
            <div className="min-h-screen grid place-items-center text-gray-500" data-testid="auth-loading">
                Loading…
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (role && user.role !== role) {
        const home = user.role === "admin" ? "/admin"
            : user.role === "doctor" ? "/doctor"
            : user.role === "employer" ? "/employer"
            : "/dashboard";
        return <Navigate to={home} replace />;
    }
    return children;
}
